import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import MarketingLayout from '../components/marketing/MarketingLayout';
import { useAuth } from '../context/AuthContext';

export default function PaymentFailedPage() {
  const { currentUser } = useAuth();
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason') || 'failed';
  const cancelled = reason === 'cancelled';

  return (
    <MarketingLayout>
      <header className="mk-page-hero">
        <div className="mk-container">
          <span className="mk-eyebrow">Payment</span>
          <h1>{cancelled ? 'Payment cancelled' : 'Payment failed'}</h1>
          <p>
            {cancelled
              ? 'You left checkout before the payment was completed. No charge was finalized.'
              : 'We could not complete your payment. You can try again or contact support for help.'}
          </p>
        </div>
      </header>

      <section className="mk-section">
        <div className="mk-container">
          <div className="mk-result-card">
            <div className="mk-result-icon is-failed">
              <span className="material-symbols-outlined" style={{ fontSize: 36 }}>
                {cancelled ? 'cancel' : 'error'}
              </span>
            </div>
            <h2>{cancelled ? 'Checkout cancelled' : 'Something went wrong'}</h2>
            <p>
              {cancelled
                ? 'Your cart and account are unchanged. Return anytime to finish enrollment.'
                : 'Please verify your payment details and try again. If the problem continues, reach out to our advisors.'}
            </p>
            <div className="mk-inline-actions" style={{ justifyContent: 'center', marginTop: 24 }}>
              {currentUser ? (
                <Link to="/billing" className="mk-btn mk-btn-primary">
                  Retry payment
                </Link>
              ) : (
                <Link to="/checkout" className="mk-btn mk-btn-primary">
                  Return to checkout
                </Link>
              )}
              <Link to="/contact" className="mk-btn mk-btn-secondary">
                Contact support
              </Link>
            </div>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
